import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorService } from '../../error';
import { SearchRequest } from '../search/types';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { FileModel } from './types';

@Injectable({ providedIn: 'root' })
export class ExportApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  exportToCsv = (searchRequest: SearchRequest): Observable<FileModel> => {
    let parameters: string[];
    parameters = ['api', searchRequest.url, 'export'];
    const parameter = new HttpParams()
      .set('pageIndex', searchRequest.pageIndex)
      .set('pageSize', searchRequest.pageSize)
      .set('orderBy', `${searchRequest.sortBy} ${searchRequest.orderBy}`);
    let url = environment.comparanooapiurl;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return this.httpClient
      .post<FileModel>(url, searchRequest.filters, {
        params: parameter,
      })
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };
}
